import { render, staticRenderFns } from "./form-request-pickup.vue?vue&type=template&id=285fac5a&"
import script from "./form-request-pickup.vue?vue&type=script&lang=js&"
export * from "./form-request-pickup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports